import { DefaultLandingPage } from "../DefaultLandingPage";
import * as React from "react";

const SignedOutPage = () => {
    return <DefaultLandingPage />;
};

export default SignedOutPage;